/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_donut_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free online donut chart maker. Paste labels and values to get an instant, colourful donut chart with percentages.`)
};

const es_donut_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creador gratuito de gráficos de dona online. Pega etiquetas y valores para obtener un gráfico de dona instantáneo y colorido con porcentajes.`)
};

const de_donut_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Online-Donut-Diagramm-Ersteller. Fügen Sie Bezeichnungen und Werte ein und erhalten Sie sofort ein farbenfrohes Donut-Diagramm mit Prozentangaben.`)
};

const nl_donut_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis online donutdiagrammaker. Plak labels en waarden om direct een kleurrijk donutdiagram met percentages te krijgen.`)
};

const fr_donut_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créateur gratuit de diagramme en anneau en ligne. Collez des étiquettes et des valeurs pour obtenir instantanément un diagramme en anneau coloré avec pourcentages.`)
};

const it_donut_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creatore gratuito di grafici a ciambella online. Incolla etichette e valori per ottenere un grafico a ciambella istantaneo e colorato con le percentuali.`)
};

const pt_br2_donut_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador gratuito online de gráfico de rosca. Cole rótulos e valores para obter um gráfico de rosca instantâneo e colorido com percentuais.`)
};

const pt_donut_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criador gratuito de gráficos de rosca online. Cole rótulos e valores e obtenha instantaneamente um gráfico de rosca colorido com percentagens.`)
};

const ja_donut_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のオンラインドーナツグラフ作成ツール。ラベルと値を貼り付けると、パーセンテージ付きの見やすいドーナツグラフが即座に得られます。`)
};

const zh_donut_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费在线环形图制作工具。粘贴标签和数值即可获得带百分比的即时多彩环形图。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const donut_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.donut_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("donut_meta_description", locale)
	if (locale === "en") return en_donut_meta_description(inputs)
	if (locale === "es") return es_donut_meta_description(inputs)
	if (locale === "de") return de_donut_meta_description(inputs)
	if (locale === "nl") return nl_donut_meta_description(inputs)
	if (locale === "fr") return fr_donut_meta_description(inputs)
	if (locale === "it") return it_donut_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_donut_meta_description(inputs)
	if (locale === "pt") return pt_donut_meta_description(inputs)
	if (locale === "ja") return ja_donut_meta_description(inputs)
	return zh_donut_meta_description(inputs)
};